import { useRevalidator } from '@remix-run/react';
import { useEffect } from 'react';
import cookieScriptProdUrl from '#common/assets/cookiescript/prod.js?url';
import cookieScriptStageUrl from '#common/assets/cookiescript/stage.js?url';
import { FakeConsent } from '#common/components/FakeConsentBanner.tsx';
import { getAllPublicEnv } from '#speaker-shop/utils/public-env.tsx';

export function ConsentHandling() {
    const revalidator = useRevalidator();

    useEffect(() => {
        const onEvent = () => {
            revalidator.revalidate();
        };

        window.addEventListener('CookieScriptAccept', onEvent);
        window.addEventListener('CookieScriptReject', onEvent);
        return () => {
            window.removeEventListener('CookieScriptAccept', onEvent);
            window.removeEventListener('CookieScriptReject', onEvent);
        };
    }, [ revalidator ]);

    const env = getAllPublicEnv();
    if (env.NODE_ENV === 'development') {
        return <FakeConsent />;
    }

    const cookieScriptSource = env.ENV === 'stage' ? cookieScriptStageUrl : cookieScriptProdUrl;

    return <script type='text/javascript' src={cookieScriptSource}></script>;
}

function getCookieValue(name: string): string | null {
    if (typeof document === 'undefined') {
        return null;
    }
    const matches = document.cookie.match(
        new RegExp(
            '(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'
        )
    );
    return matches?.[1] ? decodeURIComponent(matches[1]) : null;
}

export function getAcceptedCategories() {
    const existingCookieValue = getCookieValue('CookieScriptConsent');
    let existingCategories: string[] = [];
    let existingGoogleConsentMap: Record<string, string> = {};

    if (existingCookieValue) {
        try {
            const existingConsent = JSON.parse(existingCookieValue);
            if (existingConsent.action === 'accept') {
                // Parse existing categories (it's a JSON string)
                if (typeof existingConsent.categories === 'string') {
                    existingCategories = JSON.parse(existingConsent.categories);
                } else if (Array.isArray(existingConsent.categories)) {
                    existingCategories = existingConsent.categories;
                }

                // Preserve existing Google consent map
                if (existingConsent.googleconsentmap) {
                    existingGoogleConsentMap = existingConsent.googleconsentmap;
                }
            }
        } catch {
            // Invalid existing cookie, start fresh
        }
    }
    return { existingCategories, existingGoogleConsentMap };
}
